import { Locale } from 'modules/i18n';

export const chainTypeSelectorWithSubchainsTranslation = {
  [Locale.en]: {
    mainnet: 'Mainnet',
    testnet: 'Testnet',
    signet: 'Signet',
    devnet: 'Devnet',
    beaconsMainnet: 'Beacon mainnet',
    beaconsTestnet: 'Beacon testnet',
    opnodesMainnet: 'Opnode mainnet',
    opnodesTestnet: 'Opnode testnet',
  },
};
